import { parseJsonValue } from '@/lib/json';

export type DisplayTextConfig = {
  brandTop: string;
  brandBottom: string;
  brandSubtext: string;
  brandImageUrl: string;
  brandLogoHeight: number;
  siteTitle: string;
  siteDescription: string;
  shareImageUrl: string;
};

export const defaultDisplayTextConfig: DisplayTextConfig = {
  brandTop: 'DN',
  brandBottom: 'TECH',
  brandSubtext: 'dntechstore.com',
  brandImageUrl: '',
  brandLogoHeight: 28,
  siteTitle: 'DN TECH - Chuyen cung cap linh kien PC, Laptop, Gaming Gear',
  siteDescription:
    'Chuyen kinh doanh linh kien may tinh, PC, laptop, gaming gear, phu kien, thiet bi dien tu hang dau Viet Nam',
  shareImageUrl: '',
};

export function normalizeDisplayTextConfig(rawValue: unknown): DisplayTextConfig {
  const parsed = parseJsonValue<Partial<DisplayTextConfig>>(rawValue, {});
  const readString = (value: unknown, fallback: string) => {
    if (value === null || value === undefined) return fallback;
    return String(value).trim();
  };
  const readLogoHeight = (value: unknown, fallback: number) => {
    if (value === null || value === undefined || value === '') return fallback;
    const parsedValue = Number(value);
    if (!Number.isFinite(parsedValue)) return fallback;
    return Math.min(120, Math.max(24, Math.round(parsedValue)));
  };

  return {
    brandTop: readString(parsed.brandTop, defaultDisplayTextConfig.brandTop),
    brandBottom: readString(parsed.brandBottom, defaultDisplayTextConfig.brandBottom),
    brandSubtext: readString(parsed.brandSubtext, defaultDisplayTextConfig.brandSubtext),
    brandImageUrl: readString(parsed.brandImageUrl, defaultDisplayTextConfig.brandImageUrl),
    brandLogoHeight: readLogoHeight(
      parsed.brandLogoHeight,
      defaultDisplayTextConfig.brandLogoHeight
    ),
    siteTitle: readString(parsed.siteTitle, defaultDisplayTextConfig.siteTitle),
    siteDescription: readString(parsed.siteDescription, defaultDisplayTextConfig.siteDescription),
    shareImageUrl: readString(parsed.shareImageUrl, defaultDisplayTextConfig.shareImageUrl),
  };
}
